//#region src/utils/formatters.ts
var e = "es-AR";
function t(t, n = "ARS", r = {}) {
	let { compact: i = !1, showCode: a = !0 } = r;
	try {
		return i ? new Intl.NumberFormat(e, {
			style: "currency",
			currency: n,
			currencyDisplay: a ? "code" : "symbol",
			notation: "compact",
			compactDisplay: "short"
		}).format(t) : new Intl.NumberFormat(e, {
			style: "currency",
			currency: n,
			currencyDisplay: a ? "code" : "symbol",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}).format(t);
	} catch (e) {
		return console.error(`Failed to format currency: ${n}`, e), `${a ? `${n} ` : "$"}${t.toFixed(2)}`;
	}
}
function n(e, n = "ARS") {
	return t(e, n, { compact: !0 });
}
function r(t, n = 2) {
	return new Intl.NumberFormat(e, {
		minimumFractionDigits: n,
		maximumFractionDigits: n
	}).format(t);
}
function i(t, n = 2) {
	return new Intl.NumberFormat(e, {
		style: "percent",
		minimumFractionDigits: n,
		maximumFractionDigits: n
	}).format(t);
}
function a(t, n = {}) {
	let { style: r = "medium", showTime: i = !1 } = n, a = typeof t == "string" ? new Date(t) : t, o = { dateStyle: {
		short: "short",
		medium: "medium",
		long: "long"
	}[r] };
	return i && (o.timeStyle = "short"), new Intl.DateTimeFormat(e, o).format(a);
}
function o(e) {
	let t = /* @__PURE__ */ new Date(), n = typeof e == "string" ? new Date(e) : e, r = t.getTime() - n.getTime(), i = Math.floor(r / 6e4), o = Math.floor(i / 60), s = Math.floor(o / 24);
	return i < 1 ? "Ahora" : i < 60 ? `Hace ${i} min` : o < 24 ? `Hace ${o}h` : s < 7 ? `Hace ${s}d` : a(n, { style: "medium" });
}
var s = e, c = {
	thumb: 75,
	low: 200,
	medium: 500,
	high: 0
}, l = {
	thumb: "_75",
	low: "_200",
	medium: "_500",
	high: ""
}, u = /_(?:75|200|500)$/;
function d(e, t = "high") {
	if (!e) return "";
	if (t === "high") return e;
	let n = l[t];
	if (e.lastIndexOf(".") === -1) return e;
	let r = e.indexOf("?"), i = r === -1 ? e : e.substring(0, r), a = r === -1 ? "" : e.substring(r), o = i.lastIndexOf(".");
	if (o === -1) return e;
	let s = i.substring(0, o), c = i.substring(o);
	return u.test(s) ? `${s.replace(u, "")}${n}${c}${a}` : `${s}${n}${c}${a}`;
}
function f(e) {
	let t = e * 1.5;
	return t <= c.thumb ? "thumb" : t <= c.low ? "low" : t <= c.medium ? "medium" : "high";
}
function p(e) {
	return e.includes("/icecat/") || e.includes("icecat.biz");
}
function m(e) {
	return e.includes("/merchants/");
}
//#endregion
//#region src/utils/businessHours.ts
var h = [
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday",
	"sunday"
], g = {
	es: {
		monday: "Lun",
		tuesday: "Mar",
		wednesday: "Mié",
		thursday: "Jue",
		friday: "Vie",
		saturday: "Sáb",
		sunday: "Dom"
	},
	en: {
		monday: "Mon",
		tuesday: "Tue",
		wednesday: "Wed",
		thursday: "Thu",
		friday: "Fri",
		saturday: "Sat",
		sunday: "Sun"
	},
	pt: {
		monday: "Seg",
		tuesday: "Ter",
		wednesday: "Qua",
		thursday: "Qui",
		friday: "Sex",
		saturday: "Sáb",
		sunday: "Dom"
	},
	ru: {
		monday: "Пн",
		tuesday: "Вт",
		wednesday: "Ср",
		thursday: "Чт",
		friday: "Пт",
		saturday: "Сб",
		sunday: "Вс"
	}
};
function _(e, t) {
	return g[t.split("-")[0]]?.[e] ?? g.es[e] ?? e;
}
function v(e, t = "es") {
	let n = [];
	for (let t of h) {
		let r = e[t];
		if (!r || r.closed) continue;
		let i = `${r.open}-${r.close}`, a = n[n.length - 1];
		a && a.schedule === i ? a.days.push(t) : n.push({
			days: [t],
			schedule: i
		});
	}
	return n.length === 0 ? [] : n.map((e) => {
		let n = _(e.days[0], t), r = _(e.days[e.days.length - 1], t);
		return `${e.days.length > 1 ? `${n}-${r}` : n}: ${e.schedule}`;
	});
}
function y(e) {
	let t = /* @__PURE__ */ new Date(), n = t.getDay(), r = e[h[n === 0 ? 6 : n - 1]];
	if (!r || r.closed || !r.open || !r.close) return !1;
	let [i, a] = r.open.split(":").map(Number), [o, s] = r.close.split(":").map(Number), c = t.getHours() * 60 + t.getMinutes(), l = i * 60 + (a || 0), u = o * 60 + (s || 0);
	return c >= l && c < u;
}
//#endregion
export { f as a, s as c, a as d, r as f, d as i, t as l, o as m, y as n, p as o, i as p, c as r, m as s, v as t, n as u };

//# sourceMappingURL=businessHours-AQmzZWFt.js.map